// extracted by mini-css-extract-plugin
export var section = "styles-module--section--eV4z5";
export var smallSpacing = "styles-module--smallSpacing--SwV8O";
export var largeSpacing = "styles-module--largeSpacing--dfczv";
export var sectionBg = "styles-module--sectionBg--sPodb";
export var container = "styles-module--container--NI5zn";